// extracted by mini-css-extract-plugin
export default {"root":"_1Ugyu","variant-horizontal":"_3Xg9o","variantHorizontal":"_3Xg9o","title":"_1OHbp","message":"ybWvS","core-star":"_2WxVF","coreStar":"_2WxVF"};